// Cancel.js
import React from "react";

const Cancel = () => {
  return (
    <div>
      <h1>Payment Canceled</h1>
      <p>Your payment was canceled. Feel free to try again.</p>
    </div>
  );
};

export default Cancel;
